import { emailRegex, isAliasedEmail, phoneRegex } from "@lib/util/regex"
import * as Yup from "yup"

const isValidVariantObject = (variant: any) => {
    return variant.id !== "" && variant.title !== "" && variant.price !== 0
}

const emailValidation = Yup.string()
    .matches(emailRegex, "Invalid email address")
    .test('no-alias', "Aliased email addresses (e.g., addresses with a '+' symbol) are not allowed. Please enter a valid email address.",
        value => value ? !isAliasedEmail(value) : true
    )

export const validationSchema = Yup.object().shape({
    toName: Yup.string().required("Recipient’s name is required"),

    fromName: Yup.string().required("Name is required"),

    variant: Yup.mixed().test(
        "isValidVariantObject",
        "Amount is required",
        isValidVariantObject
    ),

    quantity: Yup.number().required("Quantity is required"),
    message: Yup.string().max(250, "Message must be less than 250 characters"),
    deliveryMethod: Yup.string().required("Delivery Method is required"),

    toPhone: Yup.string().when("deliveryMethod", ([deliveryMethod], schema) =>
        deliveryMethod === "Text"
            ? schema
                .required("Recipient’s phone numbers is required")
                .matches(phoneRegex, "Invalid phone number")
            : schema.nullable()
    ),
    toPhoneConfirm: Yup.string()
        .nullable()
        .when("deliveryMethod", ([deliveryMethod], schema) =>
            deliveryMethod === "Text"
                ? schema
                    .oneOf(
                        [Yup.ref("toPhone"), null],
                        "Phone numbers must match"
                    )
                    .required("Confirm phone number is required")
                : schema.nullable()
        ),
    toEmail: Yup.string().when("deliveryMethod", ([deliveryMethod], schema) =>
        deliveryMethod === "Email"
            ? schema
                .concat(emailValidation)
                .required("Recipient's email address is required")
            : schema.nullable()
    ),
    toEmailConfirm: Yup.string()
        .nullable()
        .when("deliveryMethod", ([deliveryMethod], schema) =>
            deliveryMethod === "Email"
                ? schema
                    .oneOf(
                        [Yup.ref("toEmail"), null],
                        "Email addresses must match"
                    )
                    .required("Confirm email addresses is required")
                : schema.nullable()
        ),
    fromEmail: Yup.string().when("deliveryMethod", ([deliveryMethod], schema) =>
        // deliveryMethod === "Email" ||
        // deliveryMethod === "Text" ||
        deliveryMethod === "Print"
            ? schema
                .concat(emailValidation)
                .required("Email address is required")
            : schema.nullable()
    ),
})
